var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Banner'),_c('company-profile'),_c('service-items'),_c('customer-reviews'),_c('Partnership')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }